/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';

interface GSTR1ReportItem {
  serialNumber: number;
  branch: string;
  billNo: string;
  billDate: string;
  billValue: number;
  gstRate: number;
  taxableValue: number;
  cgst: number;
  sgst: number;
}

interface GSTR1ReportProps {
  data: GSTR1ReportItem[];
}

const formatDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

const columns: ColumnsType<GSTR1ReportItem> = [
  {
    title: 'S.No',
    dataIndex: 'serialNumber',
    key: 'serialNumber',
    render: (val: number) => (val === -1 ? '' : val),
  },
  {
    title: 'Branch',
    dataIndex: 'branch',
    key: 'branch',
  },
  {
    title: 'Bill No',
    dataIndex: 'billNo',
    key: 'billNo',
  },
  {
    title: 'Bill Date',
    dataIndex: 'billDate',
    key: 'billDate',
    render: (date: string) => (date ? formatDate(date) : ''),
  },
  {
    title: 'Bill Value',
    dataIndex: 'billValue',
    key: 'billValue',
    render: (val: number) => fmt.format(val),
  },
  {
    title: 'GST %',
    dataIndex: 'gstRate',
    key: 'gstRate',
    render: (val: number) => `${val}%`,
  },
  {
    title: 'Taxable Value',
    dataIndex: 'taxableValue',
    key: 'taxableValue',
    render: (val: number) => fmt.format(val),
  },
  {
    title: 'CGST',
    dataIndex: 'cgst',
    key: 'cgst',
    render: (val: number) => fmt.format(val),
  },
  {
    title: 'SGST',
    dataIndex: 'sgst',
    key: 'sgst',
    render: (val: number) => fmt.format(val),
  },
];

const GSTR1ReportDisplay: React.FC<GSTR1ReportProps> = ({ data }) => {
  const totalBillValue = parseFloat(data.reduce((sum, row) => sum + (row.billValue || 0), 0).toFixed(2));
  const totalTaxableValue = parseFloat(data.reduce((sum, row) => sum + (row.taxableValue || 0), 0).toFixed(2));
  const totalCgst = parseFloat(data.reduce((sum, row) => sum + (row.cgst || 0), 0).toFixed(2));
  const totalSgst = parseFloat(data.reduce((sum, row) => sum + (row.sgst || 0), 0).toFixed(2));

  const totalsRow: GSTR1ReportItem = {
    serialNumber: -1,
    branch: '',
    billNo: 'Total',
    billDate: '',
    billValue: totalBillValue,
    gstRate: 18,
    taxableValue: totalTaxableValue,
    cgst: totalCgst,
    sgst: totalSgst,
  };

  const tableData = [...data, totalsRow];

  return (
    <div className="loan-data-container">
      <h2>GSTR1 Report</h2>
      <Table
        columns={columns}
        dataSource={tableData}
        rowKey={(row) => row.billNo || 'total'}
        pagination={false}
        rowClassName={(_, idx) => (idx === tableData.length - 1 ? 'totals-row' : '')}
      />
    </div>
  );
};

export default GSTR1ReportDisplay;
